module.exports = __webpack_public_path__ + "img/dealer-name-marquee.281c0579.png";